import { useEffect, useState } from 'react'
import { Button, NativeSelect, Text, VStack, Field, Dialog, CloseButton } from '@chakra-ui/react';
import { ResponsiveModal } from '../../shared'

interface AutoBuildDialogProps {
  isOpen: boolean
  onClose: () => void
  targetCount: number
  isBuilding?: boolean
  onBuild: (durationMin: number) => void
}

export function AutoBuildDialog({ isOpen, onClose, targetCount, isBuilding, onBuild }: AutoBuildDialogProps) {
  const [duration, setDuration] = useState(30)

  // Reset to the default duration each time the dialog opens (matches CreateMeetingPopover).
  useEffect(() => {
    if (isOpen) setDuration(30)
  }, [isOpen])

  return (
    <ResponsiveModal isOpen={isOpen} onClose={onClose} isCentered size="md">
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content>
          <Dialog.Header>Auto-build itinerary</Dialog.Header>
          <Dialog.CloseTrigger asChild><CloseButton size="sm" /></Dialog.CloseTrigger>
          <Dialog.Body>
            <VStack align="stretch" gap={4}>
              <Text fontSize="sm">
                {targetCount > 0
                  ? `This will create ${targetCount} meeting${targetCount === 1 ? '' : 's'} for your target legislators without one and assign their constituents. Existing meetings are left as-is. Changes are staged until you Save.`
                  : 'No target legislators need a meeting right now. Nothing to build.'}
              </Text>
              <Field.Root>
                <Field.Label htmlFor="auto-build-duration">Meeting duration</Field.Label>
                <NativeSelect.Root>
                  <NativeSelect.Field
                    id="auto-build-duration"
                    value={duration}
                    onChange={(e) => setDuration(Number(e.target.value))}>
                    <option value={30}>30 minutes</option>
                    <option value={45}>45 minutes</option>
                    <option value={60}>60 minutes</option>
                  </NativeSelect.Field>
                  <NativeSelect.Indicator />
                </NativeSelect.Root>
              </Field.Root>
            </VStack>
          </Dialog.Body>
          <Dialog.Footer>
            <Button variant="ghost" mr={3} onClick={onClose} minH="44px">Cancel</Button>
            <Button
              colorPalette="brand"
              minH="44px"
              disabled={targetCount === 0}
              loading={isBuilding}
              onClick={() => onBuild(duration)}
            >
              Build itinerary
            </Button>
          </Dialog.Footer>
        </Dialog.Content>
      </Dialog.Positioner>
    </ResponsiveModal>
  );
}
